import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Shield, Lock } from 'lucide-react';
import Footer from '../components/Footer';

const Privacy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0a111e] flex flex-col">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 -left-1/4 w-[600px] h-[600px] bg-pink-500/20 rounded-full blur-[180px] animate-pulse" />
        <div className="absolute -bottom-1/4 -right-1/4 w-[600px] h-[600px] bg-blue-500/10 rounded-full blur-[180px] animate-pulse-slow" />
      </div>

      <button
        onClick={() => navigate('/')}
        className="fixed top-8 left-8 z-20 flex items-center gap-2 px-4 py-2 bg-[#0F1824] rounded-lg border border-white/[0.05] text-white hover:border-pink-500/50 transition-all duration-300 group"
      >
        <ArrowLeft className="h-5 w-5 text-pink-500 group-hover:transform group-hover:-translate-x-1 transition-transform" />
        <span>Back</span>
      </button>

      <main className="flex-1 relative z-10 py-16 px-4">
        <div className="max-w-4xl mx-auto mt-12">
          <div className="text-center mb-12">
            <Shield className="h-16 w-16 text-pink-500 mx-auto mb-6" />
            <h1 className="text-4xl font-bold text-white mb-4">Privacy Policy</h1>
            <p className="text-xl text-gray-400">Protecting Your Data is Our Priority</p>
          </div>

          <div className="bg-[#0F1824] rounded-2xl border border-white/[0.05] p-8">
            <div className="space-y-8">
              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">Our Commitment to Privacy</h2>
                <p className="text-gray-400">
                  At TiccAI, we understand that privacy and data protection are fundamental concerns for our users, especially when handling sensitive support tickets and internal documentation. We are currently developing a comprehensive privacy policy that will detail our practices and commitments regarding data collection, processing, and protection.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">What to Expect</h2>
                <p className="text-gray-400">
                  Our upcoming privacy policy will provide detailed information about:
                </p>
                <ul className="mt-4 space-y-3">
                  <li className="flex items-start gap-3">
                    <div className="w-6 h-6 rounded-full bg-pink-500/10 flex items-center justify-center shrink-0 mt-1">
                      <Lock className="h-3 w-3 text-pink-500" />
                    </div>
                    <span className="text-gray-400">How we collect and use your data</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-6 h-6 rounded-full bg-pink-500/10 flex items-center justify-center shrink-0 mt-1">
                      <Lock className="h-3 w-3 text-pink-500" />
                    </div>
                    <span className="text-gray-400">Our data retention and deletion policies</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-6 h-6 rounded-full bg-pink-500/10 flex items-center justify-center shrink-0 mt-1">
                      <Lock className="h-3 w-3 text-pink-500" />
                    </div>
                    <span className="text-gray-400">Your rights regarding your personal data</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-6 h-6 rounded-full bg-pink-500/10 flex items-center justify-center shrink-0 mt-1">
                      <Lock className="h-3 w-3 text-pink-500" />
                    </div>
                    <span className="text-gray-400">How we handle data in our AI processing systems</span>
                  </li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">Current Practices</h2>
                <p className="text-gray-400">
                  While our comprehensive policy is being finalized, you can be assured that we:
                </p>
                <ul className="mt-4 space-y-3">
                  <li className="flex items-start gap-3">
                    <div className="w-6 h-6 rounded-full bg-pink-500/10 flex items-center justify-center shrink-0 mt-1">
                      <Lock className="h-3 w-3 text-pink-500" />
                    </div>
                    <span className="text-gray-400">Only collect data necessary for service operation</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-6 h-6 rounded-full bg-pink-500/10 flex items-center justify-center shrink-0 mt-1">
                      <Lock className="h-3 w-3 text-pink-500" />
                    </div>
                    <span className="text-gray-400">Implement industry-standard security measures</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-6 h-6 rounded-full bg-pink-500/10 flex items-center justify-center shrink-0 mt-1">
                      <Lock className="h-3 w-3 text-pink-500" />
                    </div>
                    <span className="text-gray-400">Never sell or share your data with third parties</span>
                  </li>
                </ul>
              </section>

              <div className="mt-8 pt-8 border-t border-white/[0.05]">
                <p className="text-gray-400">
                  For any immediate privacy concerns or questions, please contact us at{' '}
                  <a href="mailto:business@ticcai.com" className="text-pink-500 hover:text-pink-400">
                    business@ticcai.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Privacy;